import { hookstate, useHookstate } from '@hookstate/core';

const appState = hookstate({ isSidebarOpen: false });
export const useAppState = () => useHookstate(appState);

export const currentBoardState = hookstate({
  id: null,
  userRole: null,
  allowZoomToCircle: false,
  moveWithChildren: true,
  zoomNodeId: null,
  draggedNodeId: null,
  editedNodeId: null,
  activeDropTargetId: null
});
export const useCurrentBoard = () => useHookstate(currentBoardState).get();
export const useCurrentBoardState = () => useHookstate(currentBoardState);

export const currentUserState = hookstate({ id: null, email: null });
export const useCurrentUser = () => useHookstate(currentUserState).get();
export const useCurrentUserState = () => useHookstate(currentUserState);
